import {
  ShieldCheck, Scale, Lock, FileText, Gauge, Cloud, Globe2, Accessibility, Search, CheckCircle2, CreditCard,
  Activity, Network, Bot, Rocket, RefreshCw, Compass, ClipboardCheck, ListOrdered, BadgeCheck, FileBarChart,
  Building2, ShoppingCart, Landmark, HeartPulse, GraduationCap, Store, Briefcase,
} from "lucide-react";

export const serviceIcons = {
  "security-vulnerability-assessment": ShieldCheck, "legal-regulatory-readiness": Scale, "privacy-data-protection": Lock,
  "website-application-policies": FileText, "performance-speed": Gauge, "cloud-infrastructure-devops": Cloud,
  "country-specific-compliance": Globe2, accessibility: Accessibility, "technical-seo": Search, "quality-assurance": CheckCircle2,
  "payments-ecommerce": CreditCard, "reliability-incident-readiness": Activity, "third-party-supply-chain-risk": Network,
  "ai-security-governance": Bot, "launch-readiness": Rocket, "continuous-assurance": RefreshCw,
};

export const stepIcons = [Compass, ClipboardCheck, ListOrdered, BadgeCheck, FileBarChart];

export const industryIcons = { saas: Building2, ecommerce: ShoppingCart, fintech: Landmark, health: HeartPulse, edtech: GraduationCap, ai: Bot, marketplaces: Store, agencies: Briefcase };

export const IconTile = ({ icon: I, dark = false, className = "" }) =>
  I ? (
    <span className={`inline-flex h-12 w-12 flex-none items-center justify-center rounded-xl ${dark ? "bg-white/10 text-teal-bright" : "bg-teal/10 text-teal"} ${className}`} aria-hidden>
      <I className="h-6 w-6" strokeWidth={1.8} />
    </span>
  ) : null;
